import Agent from "app/Agent/config"

const serviceProviders = {
    Agent,
};

export default serviceProviders;
